module.exports = __webpack_public_path__ + "img/mcafee.2528bcc0.png";